import * as React from "react";

const SvgComponent = () => (
  <svg width="80.000000" height="80.000000" viewBox="0 0 80 80" fill="none">
    <defs>
      <clipPath id="clip1505_1015">
        <rect id="Frame" width="80.000000" height="80.000000" fill="white" fill-opacity="0" />
      </clipPath>
    </defs>
    <rect id="Frame" width="80.000000" height="80.000000" fill="#FFFFFF" fill-opacity="0" />
    <g clip-path="url(#clip1505_1015)">
      <path
        id="Vector"
        d="M6.66797 73.334C6.66797 58.6055 18.6055 46.668 33.3359 46.668C48.0625 46.668 60 58.6055 60 73.334L53.3359 73.334C53.3359 62.2891 44.3789 53.334 33.3359 53.334C22.2891 53.334 13.3359 62.2891 13.3359 73.334L6.66797 73.334ZM33.3359 43.334C22.2852 43.334 13.3359 34.3848 13.3359 23.334C13.3359 12.2832 22.2852 3.33398 33.3359 3.33398C44.3828 3.33398 53.3359 12.2832 53.3359 23.334C53.3359 34.3848 44.3828 43.334 33.3359 43.334ZM33.3359 36.668C40.7031 36.668 46.668 30.7012 46.668 23.334C46.668 15.9668 40.7031 10 33.3359 10C25.9688 10 20 15.9668 20 23.334C20 30.7012 25.9688 36.668 33.3359 36.668ZM60.9453 49.0098C70.2148 53.1875 76.668 62.5078 76.668 73.334L70 73.334C70 65.2148 65.1641 58.2246 58.2109 55.0918L60.9453 49.0098ZM58.6562 11.3789C65.3164 14.125 70 20.6797 70 28.334C70 37.9004 62.6836 45.752 53.3359 46.5918L53.3359 39.8828C58.9922 39.0742 63.3359 34.2148 63.3359 28.334C63.3359 23.7324 60.6719 19.7539 56.8047 17.8555L58.6562 11.3789Z"
        fill="#1979F3"
        fill-opacity="1.000000"
        fill-rule="nonzero"
      />
    </g>
  </svg>
);

export default SvgComponent;
